import React from 'react';
import { styled } from '../../../../styles';

export const Bullet: React.FC<React.PropsWithChildren<React.HTMLAttributes<HTMLSpanElement>>> = (props) => (
  <StyledBullet {...props}>•</StyledBullet>
);

const StyledBullet = styled('span')`
  font-size: 14px;
  padding: 0 0.5rem;
`;
